<template>
  <v-form ref="form">
    <v-row>
      <div class="inputSearch">
        <v-row>
          <v-col cols="12" md="4" lg="4">
            <v-autocomplete
              v-model="selectedPeriod"
              clear-icon="mdi-close"
              :items="sortPeriods"
              item-text="title"
              item-value="id"
              label="Kỳ đóng"
              :rules="[rules.required]"
              clearable
              outlined
              dense
              return-object
              class="required style"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="4">
            <v-autocomplete
              v-model="typeGroup"
              clear-icon="mdi-close"
              :items="typeGroups"
              item-text="title"
              item-value="type"
              label="Phân loại nhóm"
              clearable
              outlined
              dense
              hide-details
              return-object
              class="required style"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="4">
            <v-autocomplete
              :disabled="isDisable"
              v-model="group"
              :items="groups"
              item-text="title"
              item-value="id"
              clear-icon="mdi-close"
              label="Nhóm đối tượng"
              hide-details
              outlined
              dense
              required
              :loading="loading"
              class="required style"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
      </div>
      <div class="buttonSearch ml-6">
        <div class="d-flex flex-column justify-start">
          <v-btn :disabled="loading" class="search-button" @click="onFilterChange" outlined>
            Tìm kiếm
          </v-btn>
        </div>
      </div>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { sortPeriod } from '@/modules/tuitionFee/head-fee/helper/period.js'
import { textHelpers } from '@/helpers/TextHelper'
import { inputRules } from '@/plugins/rule'

export default {
  data: () => ({
    selectedPeriod: null,
    loading: false,
    rules: inputRules,
    typeGroup: null,
    isDisable: true,
    group: {},
    groups: [],

    typeGroups: [
      {
        title: 'Nhóm đối tượng chịu phí',
        type: 'normal'
      },
      {
        title: 'Nhóm đối tượng giảm trừ',
        type: 'priority'
      }
    ]
  }),
  computed: {
    ...mapGetters({
      periods: 'tuitionFeePeriod/periods',
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
      toggleFilter: 'tuitionFeeReport/toggleFilter'
    }),
    sortPeriods() {
      let periods = sortPeriod(this.periods)
      return periods
    }
  },
  async created() {
    this.clearTotalHeadFee()
    if (this.toggleFilter) {
      this.loading = true
      this.isDisable = false
      this.selectedPeriod = this.detailPeriod
      this.typeGroup = {
        title: 'Nhóm đối tượng chịu phí',
        type: 'normal'
      }
      this.group = '637f3db1ebffbb6ecfcc0df8'
      this.setPeriod(this.detailPeriod)
      this.detailPeriod &&
        (await this.getMoneyByPeriod({ idPeriod: this.detailPeriod.id, idGroup: '637f3db1ebffbb6ecfcc0df8' }))

      this.loading = false
    }
  },
  watch: {
    async typeGroup() {
      this.groups = []
      if (this.typeGroup && this.typeGroup.type) {
        this.loading = true
        this.isDisable = false
        let list = await this.fetchAll({ type: this.typeGroup.type })
        this.groups = textHelpers.sortGroupFee(list)
        this.loading = false
      } else {
        this.$refs.form.reset()
        this.isDisable = true
        this.loading = false
      }
    }
  },
  methods: {
    ...mapActions('tuitionFeeReport', ['getMoneyByPeriod', 'fetchAll']),
    ...mapMutations('tuitionFeeReport', ['setPeriod', 'clearTotalHeadFee']),
    async onFilterChange() {
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.selectedPeriod) {
          this.setPeriod(this.selectedPeriod)
          let idPeriod = this.selectedPeriod.id
          await this.getMoneyByPeriod({ idPeriod, idGroup: this.group })
        }
        this.loading = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
div.buttonSearch {
  width: 106px;
}
div.inputSearch {
  width: calc(100% - 120px - 12px);
}
@media screen and (max-width: 960px) {
  div.buttonSearch {
    width: 110px;
    padding-top: 24px;
    margin-left: 0px !important;
  }
  div.inputSearch {
    width: 100%;
  }
}
</style>
